(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/create-slide-right.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/create-slide-right.js');
"use strict";


const createSlideRightAsync = (slideComposerAsync, createToCenterTween, createToRightTween, createSetLeftTween) => async slidesList => {
  await slideComposerAsync(slidesList, createToCenterTween, createToRightTween, createSetLeftTween);
};
setGlobal('svs.components.onboarding.slides.animations.createSlideRightAsync', createSlideRightAsync);

 })(window);